import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import {
  SaleStatusCssClasses,
  SaleStatusTitles,
} from './../../../../../Sales/pages/SalesUIHelpers';
import CheckBox from '../../../../../../components/CheckBox';
import DialogBox from '../../../../../../components/DialogBox';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';

import Sale from '../Sale';
import Report from '../Report';

export const DELIVER_URL = '/deliveries';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        sales: action.payload.map((item) => {
          const updatedItem = {
            ...item,
            boxed: item.boxed === 1 ? true : false,
          };
          return updatedItem;
        }),
      };
    case 'setDeliverCode':
      console.log('DeliverCodeRedux', action.payload);
      return {
        ...state,
        deliverCode: action.payload,
      };
    case 'updateSale':
      console.log('updateSale.payload', action.payload);
      return {
        sales: state.sales.map((sale) => {
          console.log('updateSale.sale', sale);
          if (sale.saleCode === action.payload.id && sale.saleStatus > 2) {
            const updatedItem = {
              ...sale,
              boxed: action.payload.checked,
            };
            return updatedItem;
          }
          return sale;
        }),
      };
    default:
      throw new Error();
  }
}

export default function Sales(props) {
  const { deliver, setSales } = props;
  const [state, dispatch] = useReducer(reducer, { sales: [], deliverCode: '' });
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openSaleBox, setOpenSaleBox] = useState(false);
  const [sale, setSale] = useState();
  const [openReport, setOpenReport] = useState(false);

  function SaleColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-inline',
          justifyContent: 'left',
          alignItems: 'left',
        }}
      >
        <div style={{ display: 'flex' }}>
          <span style={{ fontStyle: 'bold', fontSize: 'small' }}>
            <Link to={`/sales/${cellContent}/edit`}>{cellContent}</Link>
          </span>
          <span
            style={{
              fontStyle: 'italic',
              fontSize: 'small',
              textAlign: 'right',
              alignContent: 'end',
            }}
          >
            [{row.itemCount}]
          </span>
        </div>
        <div
          style={{
            fontStyle: 'italic',
            fontSize: 'small',
          }}
        >
          {row.saleDate}
        </div>
      </div>
    );
  }
  function AmountColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-inline',
          justifyContent: 'left',
          alignItems: 'left',
        }}
      >
        <div
          style={{ display: 'flex', textAlign: 'right', justifyContent: 'end' }}
        >
          <span style={{ fontStyle: 'bold', fontSize: 'medium' }}>
            {cellContent
              ? cellContent
                  .toString()
                  .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
              : '0.00'}
          </span>
        </div>
        <div
          style={{
            fontStyle: 'italic',
            fontSize: 'small',
          }}
        >
          {row.profit
            ? row.profit
                .toString()
                .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
            : '0'}
        </div>
      </div>
    );
  }
  function StatusColumnFormatter(cellContent, row) {
    const getLabelCssClasses = () => {
      return `label label-lg label-${SaleStatusCssClasses[cellContent]} label-inline`;
    };
    return (
      <span className={getLabelCssClasses()}>
        {SaleStatusTitles[cellContent]}
      </span>
    );
  }
  function MobileColumnFormatter(cellContent, row) {
    var text = 'Copy';
    const copy = async () => {
      await navigator.clipboard.writeText(
        row.mobile2
          ? `${row.fbName}\n${cellContent}\n${row.mobile2 ? row.mobile2 : ''}`
          : `${row.fbName}\n${cellContent}`
      );
      text = 'Cpoied';
    };
    if (row.mobile2 && row.mobile2.length > 0)
      return (
        <div>
          <span>{`${cellContent}, ${row.mobile2}`}</span>{' '}
          <button className='btn btn-light sm-1' onClick={copy}>
            {text}
          </button>
        </div>
      );
    else
      return (
        <div>
          <span>{cellContent}</span>{' '}
          <button className='btn btn-light sm-1' onClick={copy}>
            {text}
          </button>
        </div>
      );
    return;
  }
  function AddressColumnFormatter(cellContent, row) {
    if (!row.location) return <span>{`Төлсөн: ${cellContent}`}</span>;
    if (row.location !== 'Ulaanbaatar')
      return <span>{`Төлсөн: ${row.district} аймаг, ${cellContent}`}</span>;
    else return <span>{`Төлсөн: ${row.district}, ${cellContent}`}</span>;
  }
  function CheckColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <CheckBox
          name='boxed'
          className='form-control form-control-sm'
          text=''
          checked={cellContent}
          changeCheckBoxValue={(e) => {
            onHandleCheck(row, e);
          }}
          disabled={row.saleStatus < 3}
        />
      </div>
    );
  }
  function ActionsColumnFormatter(cellContent, row, rowIndex) {
    return (
      <>
        <a
          title='Хүргэлт боох'
          className='btn btn-icon btn-light btn-hover-danger btn-sm'
          onClick={() => packageSale(row)}
        >
          <span className='svg-icon svg-icon-md svg-icon-danger'>
            <SVG src={toAbsoluteUrl('/media/svg/icons/Shopping/Box2.svg')} />
          </span>
        </a>
      </>
    );
  }

  const columns = [
    /*     {
      dataField: 'saleCode',
      text: 'Борлуулалт',
      sort: false,
    }, */
    {
      dataField: 'saleCode',
      text: 'Борлуулалт',
      sort: false,
      formatter: SaleColumnFormatter,
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'totalAmount',
      text: 'Дүн',
      sort: false,
      classes: 'text-right pr-2',
      style: {
        width: '80px',
      },
      formatter: AmountColumnFormatter,
    },
    {
      dataField: 'fbName',
      text: 'Нэр',
      sort: false,
      classes: 'text-left',
      style: {
        minWidth: '60px',
        width: '12rem',
      },
    },
    {
      dataField: 'mobile',
      text: 'Утас',
      sort: false,
      classes: 'text-left',
      formatter: MobileColumnFormatter,
      style: {
        minWidth: '120px',
        width: '16rem',
      },
    },
    {
      dataField: 'address',
      text: 'Хаяг',
      sort: false,
      classes: 'text-left',
      style: {
        minWidth: '60px',
        width: '50rem',
      },
      formatter: AddressColumnFormatter,
    },
    {
      dataField: 'saleStatus',
      text: 'Төлөв',
      sort: false,
      style: {
        minWidth: '30px',
        width: '4rem',
      },
      formatter: StatusColumnFormatter,
    },
    {
      dataField: 'shipDate',
      text: 'Хүргэх',
      sort: false,
    },
    {
      dataField: 'boxed',
      text: 'Бэлд- сэн',
      sort: false,
      style: {
        minWidth: '50px',
        width: '50px',
        classes: 'text-center',
      },
      formatter: CheckColumnFormatter,
    },
    {
      dataField: 'action',
      text: 'Бэл- дэх',
      formatter: ActionsColumnFormatter,
      classes: 'text-center',
      style: {
        width: '40px',
      },
    },
  ];

  useEffect(() => {
    //console.log('DeliverItemsLoaded', deliver);
    //console.log('DeliverCode', deliver.deliverCode);
    dispatch({ type: 'setDeliverCode', payload: deliver.deliverCode });
    setLoading(true);
    axios
      .post(DELIVER_URL, deliver.deliverCode, {
        headers: { action: 'getsales' },
      })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log(
              'DeliverItemsLoadedRedux',
              deliver.deliverCode,
              state.deliverCode
            );
            dispatch({ type: 'init', payload: response.data.data });

            setSales(response.data.data);

            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [deliver]);

  useEffect(() => {
    console.log('State', state);
    setSales(state.sales);
    setTotalCount(deliver.boxedCount ? deliver.boxedCount : 0);
  }, [state]);

  const onHandleCheck = (row, boxed) => {
    save(row, boxed);
  };

  const save = (row, boxed) => {
    console.log('Boxing', deliver.deliverCode, state.deliverCode, row);
    setLoading(true);
    axios
      .post(
        DELIVER_URL,
        {
          deliverCode: deliver.deliverCode,
          saleCode: row.saleCode,
          boxed: boxed === true ? 1 : 0,
        },
        { headers: { action: 'setsale' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            setBoxed(row.saleCode, boxed);
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const showReport = () => {
    setOpenReport(true);
  };

  const setBoxed = (saleCode, checked) => {
    console.log('setBoxed1', state);
    dispatch({ type: 'updateSale', payload: { id: saleCode, checked } });
    console.log('setBoxed2', state);
    setSales(state.sales);
    setTotalCount(deliver.boxedCount);
  };
  const updateBoxed = ({ saleCode, items }) => {
    let checkedCount = 0;
    let totalCount = items.length;
    items.map((item) => {
      if (item.boxed === true) checkedCount++;
    });

    if (totalCount === checkedCount) setBoxed(saleCode, true);
    else setBoxed(saleCode, false);
  };

  const packageSale = (row) => {
    setSale(row);
    setOpenSaleBox(true);
  };

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}
      <Card id='saleItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Хүргэлт - ${totalCount} (баталгаажсан)`}>
          <CardHeaderToolbar>
            {deliver.deliverCode && (
              <button
                type='button'
                className='btn btn-info ml-2'
                onClick={showReport}
              >
                <FormattedMessage id='DELIVERIES.BUTTON.PRINT'></FormattedMessage>
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={true}
            local
            keyField='saleCode'
            //data={entities === null ? [] : entities}
            data={state.sales === null ? [] : state.sales}
            columns={columns}
            //onTableChange={getHandlerTableChange(setQueryParams)}
            /*  selectRow={getSelectRow({
              entities,
              ids,
              setIds,
            })} */
          >
            {/*  <PleaseWaitMessage entities={entities} />
            <NoRecordsFoundMessage entities={entities} /> */}
            <PleaseWaitMessage entities={state.sales} />
            <NoRecordsFoundMessage entities={state.sales} />
          </BootstrapTable>
        </CardBody>
      </Card>

      {sale && (
        <Sale
          openDialog={openSaleBox}
          setOpenDialog={setOpenSaleBox}
          updateBoxed={updateBoxed}
          sale={sale}
          deliverCode={deliver.deliverCode}
        />
      )}

      {openReport && (
        <Report
          deliver={deliver}
          sales={state.sales}
          openDialog={openReport}
          setOpenDialog={setOpenReport}
        ></Report>
      )}
    </div>
  );
}
